import { useEffect, useState } from 'react';
import { API_BASE } from '../config';

// Mirrors useProperties.js's fetch/loading/error pattern, but calls the
// dedicated short-let endpoint (price-per-night, guest count, availability
// date filtering) instead of the generic /properties endpoint. Only fetches
// while `enabled` is true, so browsing rent/buy never triggers this request.
export function useShortLetProperties(params, { enabled }) {
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState('');
  const [properties, setProperties] = useState([]);

  const { state, area, minPrice, maxPrice, bedrooms, sort } = params || {};

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setError('');
      setProperties([]);
      return undefined;
    }

    let isMounted = true;
    setLoading(true);
    setError('');

    const token = localStorage.getItem('naijanest_token');
    const query = new URLSearchParams();
    if (state) query.set('state', state);
    if (area) query.set('area', area);
    if (minPrice) query.set('minPrice', minPrice);
    if (maxPrice) query.set('maxPrice', maxPrice);
    if (bedrooms) query.set('bedrooms', bedrooms);
    if (sort) query.set('sort', sort);

    fetch(`${API_BASE}/properties/short-lets?${query.toString()}`, {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (!isMounted) {
          return;
        }
        setProperties(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        if (!isMounted) {
          return;
        }
        setError(`Failed to load short-let listings: ${err.message}`);
        setProperties([]);
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [enabled, state, area, minPrice, maxPrice, bedrooms, sort]);

  return { loading, error, properties };
}
